import React from 'react';
import { X, Mail, Plus, Printer } from 'lucide-react';
import AddPaymentModal from './AddPaymentModal';

const ViewPaymentsModal = ({ sale, transaction, onClose }) => {
    // Generate dummy data based on the screenshot
    const customer = {
        name: sale?.customer || 'Ms Anjali Ramesh Patel',
        address: 'Flat 402, Green Residency,\nBandra West,\nMumbai, Maharashtra, India,\n400050',
        taxNumber: 'PAN12345K',
        mobile: '9988776655',
        email: 'anjali.patel@example.com'
    };

    const business = {
        name: "Lefty'S Liquor",
        address: '14199 E HIGHWAY 12 ROGERS,\nLittle Rock,AR,USA'
    };

    const invoice = {
        no: sale?.invoiceNo || '84_2025422711',
        date: transaction?.date || '01/26/2026',
        status: 'Due'
    };

    // Assuming no records found based on the screenshot
    const payments = [];

    const [showAddPaymentModal, setShowAddPaymentModal] = React.useState(false);

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(2px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: '2rem' }}>
            <div style={{ background: '#fff', width: '100%', maxWidth: '1100px', borderRadius: '4px', display: 'flex', flexDirection: 'column', boxShadow: '0 5px 15px rgba(0,0,0,0.3)', maxHeight: '90vh' }}>

                {/* Header */}
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 style={{ margin: 0, fontSize: '1.25rem', color: '#4b5563', fontWeight: '500' }}>
                        View Payments ( Invoice No.: {invoice.no} )
                    </h2>
                    <button onClick={onClose} style={{ border: 'none', background: 'transparent', color: '#9ca3af', cursor: 'pointer', padding: '0.2rem' }}>
                        <X size={20} />
                    </button>
                </div>

                {/* Body Content */}
                <div style={{ padding: '1.5rem', overflowY: 'auto' }}>

                    {/* Top Info Grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '2rem', marginBottom: '2rem' }}>
                        {/* Customer Info */}
                        <div style={{ fontSize: '0.85rem', color: '#4b5563', lineHeight: '1.5' }}>
                            <div style={{ marginBottom: '0.2rem' }}>Customer:</div>
                            <strong style={{ color: '#111827' }}>{customer.name}</strong> {customer.name},<br />
                            <span style={{ whiteSpace: 'pre-line' }}>{customer.address}</span><br />
                            Tax number: {customer.taxNumber}<br />
                            Mobile: {customer.mobile}<br />
                            Email: {customer.email}
                        </div>

                        {/* Business Info */}
                        <div style={{ fontSize: '0.85rem', color: '#4b5563', lineHeight: '1.5' }}>
                            <div style={{ marginBottom: '0.2rem' }}>Business:</div>
                            <strong style={{ color: '#111827' }}>{business.name}</strong> {business.name}<br />
                            <span style={{ whiteSpace: 'pre-line' }}>{business.address}</span>
                        </div>

                        {/* Invoice Info */}
                        <div style={{ fontSize: '0.85rem', color: '#4b5563', lineHeight: '1.5' }}>
                            <div><strong style={{ color: '#111827' }}>Invoice No.:</strong> #{invoice.no}</div>
                            <div><strong style={{ color: '#111827' }}>Date:</strong> {invoice.date}</div>
                            <div><strong style={{ color: '#111827' }}>Payment Status:</strong> {invoice.status}</div>
                        </div>
                    </div>

                    {/* Notification Buttons */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginBottom: '1rem' }}>
                        <button style={{ background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', fontSize: '0.85rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                            <Mail size={14} /> Send Payment Received Notification
                        </button>
                        <button style={{ background: '#f59e0b', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.5rem 0.75rem', fontSize: '0.85rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                            <Mail size={14} /> Send Payment Remider
                        </button>
                    </div>

                    {/* Add Payment Button */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
                        <button onClick={() => setShowAddPaymentModal(true)} style={{ background: '#fff', color: '#6366f1', border: '1px solid #6366f1', borderRadius: '4px', padding: '0.4rem 0.75rem', fontSize: '0.85rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.3rem', cursor: 'pointer' }}>
                            <Plus size={16} /> Add payment
                        </button>
                    </div>

                    {/* Payments Table */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem', marginBottom: '1rem' }}>
                        <thead>
                            <tr style={{ background: '#f9fafb', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb' }}>
                                {['Date', 'Reference No', 'Amount', 'Previous Hold Amount', 'Payment Method', 'Payment Note', 'Payment Account', 'Actions'].map(h => (
                                    <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left', color: '#111827', fontWeight: '700' }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {payments.length === 0 ? (
                                <tr>
                                    <td colSpan={8} style={{ padding: '1rem', textAlign: 'center', color: '#4b5563' }}>
                                        No records found
                                    </td>
                                </tr>
                            ) : (
                                payments.map((p, i) => (
                                    <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        {/* Render payment rows when data exists */}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                </div>

                {/* Footer Center Aligned as requested */}
                <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'center', gap: '0.75rem', background: '#fff', borderRadius: '0 0 4px 4px' }}>
                    <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.5rem 1.25rem', fontSize: '0.875rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer', minWidth: '80px', justifyContent: 'center' }}>
                        <Printer size={16} /> Print
                    </button>
                    <button onClick={onClose} style={{ background: '#374151', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.5rem 1.25rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer', minWidth: '80px' }}>
                        Close
                    </button>
                </div>

            </div>

            {/* Add Payment Sub-Modal */}
            {showAddPaymentModal && (
                <AddPaymentModal
                    sale={sale}
                    invoice={invoice}
                    onClose={() => setShowAddPaymentModal(false)}
                />
            )}
        </div>
    );
};

export default ViewPaymentsModal;
